import { Fragment } from "react";

import { Controller, useFieldArray, useFormContext } from "react-hook-form";

import { Delete as DeleteIcon } from "@mui/icons-material";
import { Button, IconButton, Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { CustomInputField, CustomNumberField } from "@/features/ui";

const ProductAddOnSection = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { append, remove } = useFieldArray({ control, name: "productAddOns" });
  const productAddOns = watch("productAddOns");

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between"
        }}>
        <Typography variant="h6">Add-On</Typography>
        <Button
          variant="outlined"
          onClick={() => {
            append({ additionalPrice: 0 });
          }}
        >
          Tambah
        </Button>
      </Stack>
      {productAddOns.length > 0 && (
        <Grid container spacing={3} sx={{ mt: 2 }}>
          {productAddOns.map((_, index) => (
            <Fragment key={index}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <CustomInputField
                  name={`productAddOns[${index}].name`}
                  register={register}
                  InputProps={{ placeholder: "Cth: Night Vision Coating" }}
                  helperText={errors.productAddOns?.[index]?.name?.message}
                  error={Boolean(errors.productAddOns?.[index]?.name)}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Stack direction="row" spacing={2}>
                  <Controller
                    control={control}
                    name={`productAddOns[${index}].additionalPrice`}
                    render={({ field, fieldState }) => (
                      <CustomNumberField
                        value={field.value} onChange={field.onChange}
                        required
                        helperText={fieldState.error?.message}
                        error={fieldState.invalid}
                        InputProps={{
                          placeholder: "Cth: 50.000",
                        }}
                      />
                    )}
                  />
                  <IconButton onClick={() => remove(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </Grid>
            </Fragment>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

export default ProductAddOnSection;
